import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/crae/llm',
  component: Layout,
  name: 'CraeLlm',
  meta: {
    title: 'LLM',
    icon: 'i-ant-design:cluster-outlined',
    auth: [
      'crae:llm:tool:list',
      'crae:llm:token-usage:list',
      'crae:llm:model-pricing:list',
      'crae:ai:prompt-template:list',
    ],
  },
  children: [
    {
      path: 'system-tools',
      name: 'CraeLlmSystemToolIndex',
      component: () => import('@/views/crae/llm/system-tools/index.vue'),
      meta: {
        title: '系统工具',
        icon: 'i-ant-design:tool-outlined',
        auth: 'crae:llm:tool:list',
      },
    },
    {
      path: 'token-usage',
      name: 'CraeLlmTokenUsageIndex',
      component: () => import('@/views/crae/llm/token-usage/index.vue'),
      meta: {
        title: 'Token用量',
        icon: 'i-ant-design:line-chart-outlined',
        auth: 'crae:llm:token-usage:list',
      },
    },
    {
      path: 'model-pricing',
      name: 'CraeLlmModelPricingIndex',
      component: () => import('@/views/crae/llm/model-pricing/index.vue'),
      meta: {
        title: '模型定价',
        icon: 'i-ant-design:money-collect-outlined',
        auth: 'crae:llm:model-pricing:list',
      },
    },
    {
      path: 'prompt-template',
      name: 'CraeLlmPromptTemplateIndex',
      component: () => import('@/views/crae/llm/prompt-template/index.vue'),
      meta: {
        title: '模板管理',
        icon: 'i-ant-design:form-outlined',
        auth: 'crae:ai:prompt-template:list',
      },
    },
  ],
}

export default routes
